import { API } from '@constants'

// Search API endpoints
export const API_SEARCH = `${API}/search`
export const API_REGION_LIST = `${API_SEARCH}/regionList`
export const API_EXPLORE_RESULTS = `${API_SEARCH}/exploreResults`
export const API_LOCATION_MAP = `${API_SEARCH}/locationMap`

// Search labels
export const FILTER_AND_SORT = 'Filter & Sort'
export const ALL_FILTER_AND_SORT = 'All Filter & Sort'
export const CLUB_PASS = 'Club Pass'
export const PRESIDENTIAL_RESERVE = 'Presidential Reserve'
export const ACCESSIBLE_SUITE = 'Accessible Suite'
export const FILTER_SUITE_TYPE = 'Suite Type'
export const ONSITE_AMENITIES = 'Onsite Amenities'
export const TRAVEL_STYLES = 'Travel Styles'
export const ADVENTURE_STYLES = 'Adventure Styles'
export const NEARBY_ACTIVITIES = 'Nearby Activities'
export const SEARCH_MAP = 'Map'
export const LIST = 'List'
export const VARSITY_PASS = 'Varsity Pass'
export const ACCESSIBLE_SUITES_TOOLTIP =
  'Accessible suites typically include wide doors, lower countertops, a stair-free entrance and other features intended for use by people with disabilities.'

export const LOCATION_TAB_ID = 'location'
export const DATES_TAB_ID = 'dates'

export const VIEW_MONTHLY_AVAILABILITY = 'View Monthly Availability'
// export const VIEW_AVAILABILITY = 'View Availability' // Duplicate with resort/index.ts
export const LOGIN_AVAILABILITY = 'Login to view availability'
export const STARTING_AT = 'Starting at'
export const FIND_DESTINATION = 'Find Destination'
export const PICK_LOCATION = 'Pick Location'
export const SEARCH_DATES = 'Search Dates'
export const SAVE_SEARCH = 'Save Search'
export const ALL_FILTER_SORTS = 'All Filter & Sort'
export const MAP = 'Map'
export const SEARCH_THIS_AREA = 'Search This Area'
export const WHERE_IS_YOUR_NEXT_ADVENTURE = 'Where is your next adventure?'
export const FLEXIBLE_DATES_UNSUPPORTED_MESSAGE = "This resort doesn't support flexible dates. Clear dates to access resort."
export const BONUS_TIME_UNSUPPORTED_MESSAGE = "This resort doesn't support Bonus Time. Clear dates to access resort."

/** Suggested map center and zoom per search location (e.g. state/region) for a clean initial view. Keys are lowercase. */
export const LOCATION_MAP_VIEWS: Record<string, { center: { lat: number; lng: number }; zoom: number }> = {
  tennessee: { center: { lat: 35.52, lng: -86.58 }, zoom: 6 },
  florida: { center: { lat: 27.66, lng: -81.52 }, zoom: 6 },
  california: { center: { lat: 36.78, lng: -119.42 }, zoom: 5 },
  hawaii: { center: { lat: 20.8, lng: -156.33 }, zoom: 7 },
  colorado: { center: { lat: 39.11, lng: -105.31 }, zoom: 6 },
  arizona: { center: { lat: 34.05, lng: -111.09 }, zoom: 6 },
  nevada: { center: { lat: 38.8, lng: -116.42 }, zoom: 6 },
  utah: { center: { lat: 39.32, lng: -111.09 }, zoom: 6 },
  texas: { center: { lat: 31.0, lng: -99.5 }, zoom: 5 },
  'new york': { center: { lat: 43.0, lng: -75.5 }, zoom: 6 },
  'south carolina': { center: { lat: 33.84, lng: -81.16 }, zoom: 6 },
}
export const WHERE_TO_NEXT = 'Where to Next?'
export const NO_SEARCH_RESULTS_FOUND_SNACKBAR_TEXT = "We couldn't find any results for the location you entered. Please double-check your spelling or try a different location."

export const SEARCH_DESTINATIONS = 'Search Destinations'
export const SEARCH_BY_REGION = 'Search by Region'
export const MORE_REGIONS = 'More Regions'
export const RECENT_SEARCHES = 'Recent Searches'
export const CLEAR_HISTORY = 'Clear History'
export const CLEAR_SEARCH = 'Clear Search'
export const CLOSE_SEARCH_OVERLAY = 'Close Search Overlay'
export const SAVED_SEARCHES = 'Saved Searches'
export const MORE_WAYS_TO_SEARCH = 'More Ways to Search'
export const MORE_WAYS_FLEXIBLE_PARAGRAPH = 'Choose up to three months and see the first available dates.'
export const DATE_ONLY = 'Date Only'
export const MORE_WAYS_DATE_ONLY_PARAGRAPH = 'Easily see availability for the dates you want to travel.'
export const REMOVE_SAVED_SEARCH = 'Remove Saved Search'
export const DATES_PASSED = 'Dates Passed'

// Location search labels
/** Shown in the destination field after map "Search this area" when returning to list view (geo-based search, no region). */
export const LOCATION_SEARCH = 'Location search'
export const SEARCHING_LOCATIONS = 'Searching...'
export const NO_LOCATIONS_FOUND = 'No locations found'
export const TOP_RESULTS = 'Top Results'
export const LOCATION_SEARCH_ERROR = "We couldn't find any results for the location you entered. Please double-check your spelling or try a different location."
export const DATE_PICKER_SIDEBAR_COMING_SOON = 'Coming Soon: Date Picker Sidebar'
export const DATE_PICKER_MAIN_COMING_SOON = 'Coming Soon: Date Picker Main'

// Calendar labels
export const VIEW_SAVED_SEARCHES = 'View saved searches'
export const FLEXIBLE_WITH_DATES = 'Flexible with dates?'
export const COMPARE_PRICES_TIP = 'Compare prices across different dates to find the best deals for your stay.'
export const TRAVEL_TIPS = 'Travel tips'
export const PEAK_SEASON = 'Peak season: June - August'
export const BEST_DEALS = 'Best deals: September - November'
export const BOOK_AHEAD = 'Book at least 2 months ahead'
export const WHEN_TO_TRAVEL = 'When would you like to travel?'
export const SPECIFIC_DATES = 'Specific Dates'
export const FLEXIBLE_DATES = 'Flexible Dates'
export const VIEW_RESORTS = 'View Resorts'
export const CLEAR_DATES = 'Clear Dates'
export const PLUS_MINUS_3_DAYS = '± 3 nights'
export const PLUS_MINUS_3_DAYS_TOOLTIP = 'If your travel plans are flexible, you may find more results by searching +/- 3 days from your selected date range.'
export const IM_LOOKING_FOR_A = "I'm looking for a"
export const GETAWAY = 'getaway'
export const FLEXIBLE_DATES_HELP_TEXT = 'Select up to 3 months. Months shown based on booking eligibility.'
export const LIMITED_AVAILABILITY = 'Limited availability (7 suites or less)'
export const BOOKING_WINDOW_MESSAGE =
  'The booking window for Varsity Pass is limited to 6 months in advance. Choosing dates beyond that will limit your results to Sports Illustrated Resorts only.'

// Flexible dates sidebar content
export const ABOUT_FLEXIBLE_DATES_TITLE = 'About flexible dates'
export const ABOUT_FLEXIBLE_DATES_DESCRIPTION = 'Choose up to any three months to view the first available resort dates, giving you more options when availability is limited.'
export const DATE_ONLY_SIDEBAR_TITLE = 'Date only:'
export const DATE_ONLY_NOTE = 'Easily see availability for the dates you want to travel.'

// Bonus Time sidebar content
export const ABOUT_BONUS_TIME_TITLE = 'About bonus time'
export const ABOUT_BONUS_TIME_DESCRIPTION = 'Book last-minute stays within 14 days at low cash rates—no points needed. Rates are just $5 per 1,000 points.'
export const BONUS_TIME_GUEST_NOTE = '*Guest check-ins are not allowed.'

// Search content types
export const KIND_SEARCH_AVAIL_CAL = 'searchAvailCal'

export const DEFAULT_NUMBER_OF_NIGHTS = 3
// TODO: This should really come from backend
export const LOW_AVAILABILITY_THRESHOLD = 7
// TODO: Replace with values from search constraints API endpoint
export const FLEXIBLE_NIGHTS_MIN = 2
export const FLEXIBLE_NIGHTS_MAX = 28
export const FLEXIBLE_NIGHTS_MIN_EBAC = 1
export const FLEXIBLE_NIGHTS_MAX_EBAC = 30

export const MAX_CLUB_PASS_STAY_MONTHS = 6
export const MAX_STAY_MONTHS = 14
/** Max booking months for EBAC when search constraints API is not used. */
export const MAX_STAY_MONTHS_EBAC = 13
export const NIGHTS = 'nights'
export const FIRST_CHECKOUT_DAYS_DEFAULT = 2
export const LAST_CHECKOUT_DAYS_DEFAULT = 8
export const DEFAULT_MIN_NIGHTS = 2
export const MAX_WINDOW_ERROR_CODE = 'SABRV004'

// Bonus Time constants
export const BONUS_TIME_NIGHTS_MIN = 2
export const BONUS_TIME_NIGHTS_MAX = 4
export const BONUS_TIME_TAB_LABEL = 'Bonus Time'
export const BONUS_TIME_HEADING = 'Bonus Time lets you find last-minute stays at low cash rates. '
export const BONUS_TIME_CONTENT_TEXT = 'Only eligible resorts will be displayed once Bonus Time is selected. Check-in within 2 weeks at any resort. Maximum stay of 4 nights. '
export const BONUS_TIME_SIDEBAR_TITLE = 'Bonus Time lets you find last-minute stays at low cash rates.'
export const BONUS_TIME_SIDEBAR_FOR_SPECIFIC_DATES = 'Find last-minute stays at low cash rates. '
export const BONUS_TIME_SIDEBAR_CONTENT = {
  textOne: 'About Bonus time',
  textTwo: 'Book last-minute stays within 14 days at low cash rates—no points needed. Rates are just $5 per 1,000 points.',
  textThree: '*Guest check-ins are not allowed.',
}
